module.exports = __webpack_public_path__ + "img/ltkpopulartoday-3x.ce5409e.jpg";